import API from '@Modules/Authenticate/configs/api';
import apiMethod from '@utility/ApiMethod';

export const formForgotPasswordCallMethod = ({ payload }) => {
  return apiMethod.post(API.AUTHENTICATE_FORGOT_PASSWORD, payload);
};
